a
<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <template v-if="!loading">
          <div class="flex flex_gap_10">
            <div class="form-check">
              <label>Сортировка</label>
              <select v-model="sortAlias" @change="updateSortRecords" class="form-control">
                <option value="maxDiff">Максимальная разница в продажах</option>
                <option value="maxSold">Максимальная продажи</option>
              </select>
            </div>
            <div class="form-check">
              <label>
                <input type="checkbox" v-model="showSales"> показать продажи
              </label>
            </div>
          </div>
          <div class="text-right">
            <PaginationBlock v-if="paginator" :paginator="paginator" :get-records="getRecords"/>
          </div>
          <table class="table table-sm table-hover mt-0">
            <thead>
            <tr>
              <th rowspan="2"></th>
              <th rowspan="2">ID</th>
              <th rowspan="2">препарат</th>
              <th :colspan="showSales ? 2 : 1" class="text-center border-right">c
                {{ printDate(historyDate, 'DD.MM.YYYY') }} -
                {{ soldDays }} дней
              </th>
              <th :colspan="showSales ? 2 : 1" class="text-center">c {{ printDate(startDate, 'DD.MM.YYYY') }}
                ({{ presentDaysDiff }})
              </th>
            </tr>
            <tr>
              <th align="right" v-if="showSales">продано</th>
              <th align="right" class="border-right">в день</th>
              <th>в день</th>
              <th v-if="showSales">продажи</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(r, i) in records"
                :key="r.drug_id"
                :class="{'marked_tr': r.last_sold_rate > r.preset_sold_rate}">
              <!--              <td>{{ (i + 1) + ((paginator.current_page - 1) * paginator.per_page) }}</td>-->
              <td>{{ i + 1 }}</td>
              <td>{{ r.drug_id }}</td>
              <td>{{ r.title }}</td>
              <td align="right" v-if="showSales">{{ r.total_qty }}</td>
              <td align="right" class="border-right">{{ r.last_sold_rate }}</td>
              <td>{{ r.preset_sold_rate }}</td>
              <td v-if="showSales">{{ r.present_sold }}</td>
            </tr>
            </tbody>
          </table>
        </template>
        <div class="text-right">
          <PaginationBlock v-if="paginator" :paginator="paginator" :get-records="getRecords"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import PaginationBlock from "@/components/PaginationBlock.vue";

export default {
  components: {PaginationBlock},
  data() {
    return {
      sortAlias: 'maxDiff',
      showSales: false,
      paginator: null,
      loading: true,
      historyDate: null,
      startDate: null,
      presentSold: {},
      records: [],
      soldDays: 1,
      presentDaysDiff: 1,
    }
  },
  created() {
    this.getRecords();
  },
  methods: {
    updateSortRecords() {
      console.log(this.sortAlias);
      switch (this.sortAlias) {
        case 'maxSold':
          this.records = _.orderBy(this.records, 'total_qty', 'desc');
          break;
        default:
          this.records = _.orderBy(this.records, 'sold_diff', 'desc');
          break;
      }
    },
    async getRecords(page = 1) {
      this.loading = true;
      let {data: r_data} = await api.post('/analytics/drugs/sales', {});
      // const {data, ...pagination} = r_data.records;
      // this.paginator = pagination;
      this.historyDate = r_data.history_date;
      this.startDate = r_data.start_date;
      this.soldDays = r_data.days;
      this.presentDaysDiff = r_data.present_days_diff;
      this.presentSold = r_data.presentSold;
      // this.records = data;
      this.records = r_data.records.reduce((acc, r) => {
        const lsr = Math.round(r.total_qty / this.soldDays * 10) / 10;
        const psr = Math.round((this.presentSold[r.drug_id]?.total_qty ?? 0) / this.presentDaysDiff * 10) / 10
        acc.push({
          ...r,
          present_sold: this.presentSold[r.drug_id]?.total_qty ?? 0,
          last_sold_rate: lsr,
          preset_sold_rate: psr,
          sold_diff: lsr - psr
        });
        return acc;
      }, []);
      this.updateSortRecords();
      this.loading = false;
    }
  }
}

</script>

<style scoped>
.marked_tr {
  background-color: #000d8014;
}
</style>
